import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import Filter from './Filter.jsx'
import Drawer from "@components/general/Drawer.jsx";
import { DealerContext } from '@contexts/DealerContext.jsx';
import { translate } from "../../../utility/strings.js";

const checkboxFilters = [
  // {
  //   id: "preferred_dealer",
  //   label: translate("dealer_locator.preferred_dealer", "Preferred Dealers")
  // },
  {
    id: "on_display",
    label: translate("dealer_locator.on_display", "On Display:"),
    options: [
      {
        value: "on_display_drawers",
        label: translate("dealer_locator.on_display_drawers", "Drawers")
      },
      {
        value: "on_display_toolbox",
        label: translate("dealer_locator.on_display_toolbox", "Tool Box")
      },
      {
        value: "on_display_cargoglide",
        label: translate("dealer_locator.on_display_cargoglide", "CargoGlide")
      },
      {
        value: "on_display_cases",
        label: translate("dealer_locator.on_display_cases", "Cases")
      }
    ]
  }
]


export default ({open, onClose}) => {

  const { filters } = useContext(DealerContext);
  const history = useHistory();

  const handleFilterChange = (e) => {

    const searchParams = new URLSearchParams(history.location.search);

    if (e.target.checked) {
      searchParams.set(e.target.name, e.target.value);
    } else {
      searchParams.delete(e.target.name)
    }

    const newPath = `${history.location.pathname}?${searchParams.toString()}`

    triggerFilterEvent(searchParams);

    history.replace(newPath);
  }

  return  <Drawer open={open} onClose={onClose} openFrom={"bottom"} className="ft_dealer-locator__filter-drawer" headerBordered={true}>
            <div class="h-stack items-center justify-between" slot="header">
              <div class="h-stack gap-2 sm:gap-2.5">
                <p class="h6">
                  {translate("dealer_locator.sort_by", "Filter By")}
                </p>
              </div>

              <button type="button" is="close-button" class="drawer__close-icon">
                <span class="sr-only">Close</span>
              </button>
            </div>
            <div className={`ft_dealer-locator__filters`} >
              <div className="ft_dealer-locator__filters__box">
                {checkboxFilters.map((filter) => {
                  return <>
                    <label className="ft_dealer-locator__filters__sort__label text-subdued">{filter.label}</label>
                    <div className="ft_dealer-locator__filters__sort">
                      {filter.options && filter.options.map((option) => <Filter key={option.value} label={option.label} value={true} name={option.value} checked={filters[option.value] === true || filters[option.value] === 'true'} onChange={handleFilterChange} />)}
                    </div>
                  </>
                })}
              </div>
            </div>
          </Drawer>
}


const triggerFilterEvent = (searchParams) => {
    const q = searchParams.get('q');
    const lat = searchParams.get('lat');
    const lng = searchParams.get('lng');
    const preferred_dealer = searchParams.get('preferred_dealer');
    const certified_installer = searchParams.get('certified_installer');
    const on_display_drawers = searchParams.get('on_display_drawers');
    const fleet_dealer = searchParams.get('fleet_dealer');
    const retail_dealer = searchParams.get('retail_dealer');

    if (lat && lng) {
      const event = new CustomEvent('dealerLocator:filter', { detail: { q, lat, lng, preferred_dealer, certified_installer, on_display_drawers, fleet_dealer, retail_dealer } });
      document.dispatchEvent(event);
    }
  }
